export default "__VITE_ASSET__o_BQcgC9__"